import Pagenation from "components/Pagenation";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import * as dbmsApi from "../../apis/DbmsApi";
import { apiWrapper } from "apis/CommonApi";
import { GeneralUserSearchType, getGeneralUserSearchTypeName, getUserStatusName, UserStatusChoice } from "utils/common";
import { dateFormat, getDateTime } from "utils/date";

//사용자 계정관리
export default function UserAccountManagementComponent() {
  const itemsPerPage = 100;
  const [isDelModalOpen, setIsDelModalOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSearchListOpen, setIsSearchListOpen] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("0");
  const [selectedSearchType, setSelectedSearchType] = useState("0");
  const [searchText, setSearchText] = useState("");
  const [dataSource, setDataSource] = useState([]);
  const [previous, setPrevious] = useState(null);
  const [next, setNext] = useState(null);
  const [page, setPage] = useState(1);
  const [checkedIds, setCheckedIds] = useState([]);
  const [newStatus, setNewStatus] = useState("1");

  useEffect(() => {
    getData(1);
  }, [selectedStatus]);

  //page: 1베이스
  const getData = (page, url = null) => {
    apiWrapper(async () => {
      let result;
      if (url !== null) {
        result = await dbmsApi.getGeneralUserListByUrl(url);
      } else {
        result = await dbmsApi.getGeneralUserList(
          selectedStatus,
          selectedSearchType,
          searchText,
          page,
          itemsPerPage
        );
      }

      const { status, data } = result;
      if (status === true) {
        setDataSource(data);

        setPrevious(data.previous);
        setNext(data.next);
        setPage(page);
      } else {
        alert(`${data}`);
      }
    });
  };

  const toggleSelectBox = () => {
    setIsSearchListOpen(!isSearchListOpen);
  };

  const handleSearchItemClick = (type) => {
    setSelectedSearchType(type);
    setIsSearchListOpen(false);
  };

  const handleChangeSearchText = (e) => {
    setSearchText(e.target.value);
  }

  const handleSearch = (e) => {
    if (e.type === "click" || (e.type === "keydown" && e.keyCode === 13)) {
      getData(page);
    }
  }

  const handleTabClick = (status) => {
    setSelectedStatus(status);
  };

  const handleExportExcel = () => {
    apiWrapper(async () => {
      const { status, data } = await dbmsApi.downloadExcelGeneralUserList(selectedStatus, selectedSearchType, searchText);
      if (status === false) {
        alert(`엑셀 저장에 실패하였습니다.\n${data}`);
      }
    });
  }

  const handleSaveStatus = () => {
    apiWrapper(async () => {
      const { status, data } = await dbmsApi.updateGeneralUserStatus(newStatus, checkedIds);
      alert(`${data}`)

      //업데이트 성공 시 새로고침
      if (status === true) {
        getData(page);
        closeStatusModal();
      }
    });
  }

  const openStatusModal = () => {
    if (checkedIds.length < 1) {
      alert("1개 이상 선택해주세요.");
    } else {
      setIsModalOpen(true);
      setTimeout(() => {
        const modalContent = document.querySelector(".modal_content");
        if (modalContent) {
          modalContent.style.transform = "translateX(0)";
        }
      }, 10);
    }
  }

  const closeStatusModal = () => {
    const modalContent = document.querySelector(".modal_content");
    if (modalContent) {
      modalContent.style.transform = "translateX(100%)";
    }
    setTimeout(() => {
      setIsModalOpen(false);
    }, 500);
  }

  const handleCheckAll = (e) => {
    if (e.target.checked) {
      setCheckedIds(dataSource.results.map((a) => a.id));
    } else {
      setCheckedIds([]);
    }
  };

  const handleChangeCheck = (e, id) => {
    if (e.target.checked) {
      setCheckedIds([...checkedIds, id]);
    } else {
      setCheckedIds(checkedIds.filter((a) => a !== id));
    }
  };

  const handleDelete = () => {
    apiWrapper(async () => {
      const { status, data } = await dbmsApi.bulkDeleteGeneralUser(checkedIds);
      alert(`${data}`)

      //삭제 성공 시 새로고침
      if (status === true) {
        getData(page);
        closeDelModal();
      }
    });
  }

  const openDelModal = () => {
    if (checkedIds.length < 1) {
      alert("1개 이상 선택해주세요.");
    } else {
      setIsDelModalOpen(true);
    }
  }

  const closeDelModal = () => {
    setIsDelModalOpen(false);
  }

  const handlePageArrowClick = (page, isNext) => {
    let url = null;
    if (isNext === false) {
      url = previous;
    } else {
      url = next;
    }

    getData(page, url);
  }

  return (
    <>
      <div class="viewBoard viewDBMSBoard UAMBoard">
        <div class="top_board pc">
          <p class="title_board">사용자 계정 관리</p>
          <div class="wrap_search openSearch">
            <div class="box_search">
              <div className={`select_box ${isSearchListOpen ? "open" : ""}`}>
                <button class="btn_select" onClick={toggleSelectBox}>
                  <p>{getGeneralUserSearchTypeName(selectedSearchType)}</p>
                  <i class="x-icon"></i>
                </button>
                <ul class="list_member">
                  {Object.values(GeneralUserSearchType).map(
                    (item, index) => (
                      <li onClick={() => handleSearchItemClick(item)}>
                        <p>{getGeneralUserSearchTypeName(item)}</p>
                      </li>
                    )
                  )}
                </ul>
              </div>
              <input class="" type="text" placeholder="검색어를 입력해주세요." onChange={handleChangeSearchText} onKeyDown={handleSearch} defaultValue={searchText} />
              <button class="btn_search" onClick={handleSearch}>
                <i class="x-icon icon_search"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="top_board mb">
          <div class="wrap_logo">
            {/* <!-- <img src="" alt="" class="img_logo"> --> */}
          </div>
          <div class="header_dept">
            <p class="user">COWORKER</p>
            <div class="wrap_contr">
              <Link class="set_contr" to="">
                {/* <img src="/images/my_btn_mb.png" alt=""> */}
              </Link>
            </div>
          </div>
        </div>
        <div class="top_board navi_board mb">
          <Link class="wrap_navi" to="/">
            <p class="title_navi">사용자 계정 관리</p>
          </Link>

          <div class="wrap_right mb">
            <Link class="btn_page_left" to="/dbmsMenu.html">
              <i class="x-icon"></i>
            </Link>
          </div>
        </div>


        <ul class="tabs">
          {Object.values(UserStatusChoice).map(
            (item, index) => (
              <li
                key={item}
                className={`tab-link ${selectedStatus === item ? "current" : ""}`}
                data-tab={item}
                onClick={() => handleTabClick(item)}>
                {getUserStatusName(item)}
              </li>
            )
          )}
        </ul>

        {Object.values(UserStatusChoice).map(
          (item, index) => (
            <Tab id={item} activeTab={selectedStatus} dataSource={dataSource} checkedIds={checkedIds} handleCheckAll={handleCheckAll} handleChangeCheck={handleChangeCheck} />
          )
        )}

        <div class="wrap_controll type-start">
          <div class="wrap_dbms_btn">
            <button class="item_btn" onClick={handleExportExcel}>엑셀</button>
            <button class="item_btn statusBtn" onClick={openStatusModal}>상태</button>
            <button class="item_btn" id="deleteBtn" onClick={openDelModal}>삭제</button>
          </div>
          <div id="pagination">
            <Pagenation
              totalItemsCount={dataSource.count}
              itemsPerPage={itemsPerPage}
              selectedPage={page}
              setPage={(value) => setPage(value)}
              handlePageArrowClick={handlePageArrowClick}
            />
          </div>
        </div>

        {/* <!-- 삭제 여부 모달 --> */}
        {isDelModalOpen && (
          <div id="modal" class="modal dbmsDelModal show">
            <div class="modal-content">
              <div class="modal_inner">
                <p class="modal_title">정말로 삭제하시겠습니까?</p>
                <p class="modal_sub">삭제하시면 선택하신 정보는 사라집니다.</p>
                <div class="btn-wrap">
                  <button class="modal_btn" onClick={closeDelModal}>취소</button>
                  <button class="modal_btn del_btn" onClick={handleDelete}>삭제</button>
                </div>
              </div>
            </div>
          </div>
        )}

        {isModalOpen && (
          <div id="modal" class="modal rightModal noticeRightModal open"
            onClick={(e) => {
              if (e.target === e.currentTarget)
                closeStatusModal();
            }}>
            <div class="modal_content">
              <button type="button" class="close_modal" onClick={closeStatusModal}>
                <i class="x-icon close_icon"></i>
              </button>
              <h2>사용자 계정 관리</h2>
              <div class="wrap_detail_cont wrap_detail_viewCont">
                <div class="wrap_detail_item">
                  <p class="title_detail">계정상태 변경</p>
                  <div class="detail_box detail-duble-box">
                    <div class="radio-wrap">
                      {Object.values(UserStatusChoice).map((item, index) =>
                        /* "전체" 상태는 제외하고 전시 */
                        index === 0 ? null : (
                          <label for={`radio_${index}`} class="radio-item">
                            <input type="radio" id={`radio_${index}`} class="form-radio" name="status" value={item} checked={newStatus === item} onChange={() => setNewStatus(item)} />
                            <span class="radio-icon">
                              <i class="xi-check"></i>
                            </span>
                            <p class="radio-title">{getUserStatusName(item)}</p>
                          </label>
                        )
                      )}
                    </div>
                  </div>
                </div>
                <button class="btn_dark" onClick={handleSaveStatus}>저장</button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

const Tab = ({ id, activeTab, dataSource, checkedIds, handleCheckAll, handleChangeCheck }) => {
  return (
    <div id={id} className={`tab-content ${activeTab === id ? "current" : ""}`}>
      <div class="table_board ">
        <table class="admin-table uam-table">
          <colgroup>
            <col width="3%" />
            <col width="10%" />
            <col width="10%" />
            <col width="15%" />
            <col width="17%" />
            <col width="25%" />
            <col width="15%" />
            <col width="13%" />
            <col width="13%" />
            <col width="13%" />
            <col width="13%" />
            <col width="13%" />
            <col width="13%" />
            <col width="7%" />
            <col width="11%" />
          </colgroup>
          <thead class="admin-thead">
            <tr class="admin-tr">
              <th class="admin-th">
                <input type="checkbox" name="" id="" onChange={handleCheckAll} />
              </th>
              <th class="admin-th">
                관리ID
              </th>
              <th class="admin-th">
                이름
              </th>
              <th class="admin-th">
                권한그룹
              </th>
              <th class="admin-th">
                연락처
              </th>
              <th class="admin-th">
                이메일
              </th>
              <th class="admin-th">
                로그인ID
              </th>
              <th class="admin-th">
                최초 로그인 일시
              </th>
              <th class="admin-th">
                최종 로그인 일시
              </th>
              <th class="admin-th">
                회원가입일
              </th>
              <th class="admin-th">
                회원탈퇴일
              </th>
              <th class="admin-th">
                접속유효기간 시작일
              </th>
              <th class="admin-th">
                접속유효기간 종료일
              </th>
              <th class="admin-th">
                상태
              </th>
              <th class="admin-th">
                대표관리자 여부
              </th>
            </tr>
          </thead>
          <tbody class="admin-tbody">
            {dataSource.results &&
              dataSource.results.map((item, index) => (
                <tr class="admin-tr wrap_table_item">
                  <td class="admin-td">
                    <input type="checkbox" name="" id={`check${index}`} checked={checkedIds.includes(item.id)} onChange={(e) => handleChangeCheck(e, item.id)} />
                  </td>
                  <td class="admin-td">
                    {item.id}
                  </td>
                  <td class="admin-td">
                    {item.userName}
                  </td>
                  <td class="admin-td">
                    {item.userType}
                  </td>
                  <td class="admin-td">
                    {item.phoneNumber}
                  </td>
                  <td class="admin-td">
                    {item.email}
                  </td>
                  <td class="admin-td">
                    {item.userId}
                  </td>
                  <td class="admin-td">
                    {getDateTime(new Date(item.firstLogin))}
                  </td>
                  <td class="admin-td">
                    {getDateTime(new Date(item.lastLogin))}
                  </td>
                  <td class="admin-td">
                    {dateFormat(new Date(item.createdDate))}
                  </td>
                  <td class="admin-td">
                    {item.terminatedDate ? dateFormat(new Date(item.terminatedDate)) : ''}
                  </td>
                  <td class="admin-td">
                    {dateFormat(new Date(item.validBeginDate))}
                  </td>
                  <td class="admin-td">
                    {item.validEndDate ? dateFormat(new Date(item.validEndDate)) : ''}
                  </td>
                  <td class="admin-td">
                    {item.status}
                  </td>
                  <td class="admin-td">
                    {item.isSuperAdmin === true ? "Y" : "N"}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}